// @flow strict

import React from 'react';

import {
  SvgIcon,
  type SvgIconComponentProps,
} from '~components/icons/svg-icon';

/**
 * Icon for newsletter signup.
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const NewsletterSignupIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 131 103" name="OMQNewsletterSignupIcon" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FF6602"
          d="M110.347 41.945h-.188L71.994 71.837l-4.76-3.3c-2.544-1.745-5.842-1.745-8.386 0l-4.853 3.347-38.26-29.939 10.979-5.722h72.655l10.978 5.722z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="1.35"
          d="M17.879 44.43l36.13 27.908 4.103-2.798c2.986-2.019 6.862-2.029 9.857 0l4.015 2.749 36.104-27.918-8.886-4.572H26.879l-9 4.63zm35.298 30.445L14.765 45.207c-.336-.264-.52-.68-.48-1.1.04-.425.292-.802.678-.998l11.02-5.672c.178-.093.381-.142.584-.142h72.947c.203 0 .406.05.584.142l11.02 5.672c.52.264.787.846.649 1.409-.12.464-.486.811-.941.919L72.81 74.832c-.436.337-1.05.357-1.506.039l-4.777-3.272c-2.129-1.433-4.871-1.428-6.98.005l-4.871 3.316c-.218.146-.466.22-.718.22-.277 0-.55-.088-.782-.265z"
        />
        <path
          fill="#FFF"
          d="M34.658 1.634c-2.15 0-3.934 1.792-3.934 4.008v76.776h-4.072V5.642c0-2.216 1.738-4.008 3.934-4.008h4.072z"
        />
        <path
          fill="#FFF"
          d="M99.43 19.554v62.864H28.926V5.642c0-2.216 1.893-4.008 4.173-4.008h47.893l18.438 17.92z"
        />
        <path
          fill="#FFF"
          d="M27.713 81.335h69.928V19.991L80.511 2.716H30.47c-1.52 0-2.758 1.25-2.758 2.78v75.84zM98.9 83.873H26.455c-.693 0-1.259-.57-1.259-1.269V5.497c0-2.935 2.365-5.319 5.275-5.319h50.561c.334 0 .654.134.89.372L99.79 18.569c.235.238.368.56.368.897v63.138c0 .699-.565 1.27-1.258 1.27z"
        />
        <path
          fill="#FF6602"
          d="M84.98 4.65l-3.016-3.016v14.125c0 2.25 1.819 4.07 4.07 4.07h14.124L84.98 4.65z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth=".9"
          d="M81.474 5.449v10.873c0 1.527 1.246 2.773 2.773 2.773H95.12L81.474 5.449zm16.931 15.92H84.496c-2.922 0-5.296-2.374-5.296-5.296V2.166c0-.513.306-.972.78-1.17.474-.197 1.017-.084 1.377.277l17.942 17.94c.36.36.468.902.276 1.376-.198.474-.657.78-1.17.78h0z"
        />
        <path
          fill="#FF6602"
          stroke="#FF6602"
          strokeWidth="1.35"
          d="M66.136 21.284H41.752c-.7 0-1.272-.49-1.272-1.092 0-.601.571-1.092 1.272-1.092h24.384c.7 0 1.272.491 1.272 1.092 0 .601-.571 1.092-1.272 1.092M72.696 30.745H41.742c-.695 0-1.262-.49-1.262-1.092 0-.6.567-1.091 1.262-1.091h30.954c.695 0 1.262.49 1.262 1.091 0 .602-.567 1.092-1.262 1.092M84.334 40.206H41.749c-.699 0-1.269-.49-1.269-1.092 0-.6.57-1.091 1.269-1.091h42.585c.699 0 1.269.49 1.269 1.091 0 .602-.57 1.092-1.27 1.092M84.334 49.667H41.749c-.699 0-1.269-.49-1.269-1.091 0-.602.57-1.092 1.269-1.092h42.585c.699 0 1.269.49 1.269 1.092 0 .601-.57 1.091-1.27 1.091"
        />
        <path
          fill="#FF6602"
          d="M54.308 73.916L17.54 99.156c-1.092-.946-1.805-2.32-1.805-3.883V43.845l38.573 30.071z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="1.35"
          d="M16.803 46.964v48.53c0 .798.246 1.557.71 2.202L51.644 74.2 16.803 46.964zm.527 53.648c-.296 0-.591-.103-.828-.31-1.414-1.227-2.222-2.975-2.222-4.808V44.378c0-.483.276-.921.71-1.133.428-.207.95-.163 1.33.138l38.232 29.885c.315.252.493.631.483 1.035-.015.399-.217.773-.547 1L18.044 100.39c-.216.147-.463.221-.714.221h0z"
        />
        <path
          fill="#FF6602"
          d="M110.347 43.845v51.428c0 1.563-.71 2.937-1.8 3.884L71.774 73.869l38.383-30.024h.19z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="1.35"
          d="M74.43 74.14l34.148 23.554c.462-.645.707-1.404.707-2.203v-48.7L74.43 74.14zm33.617 26.25L71.594 75.244c-.33-.227-.531-.601-.546-1-.01-.405.167-.784.481-1.036L109.58 43.35c.777-.592 2.223.02 2.223.995v51.146c0 1.834-.807 3.583-2.218 4.81-.235.208-.53.311-.826.311-.25 0-.496-.074-.712-.222z"
        />
        <path
          fill="#FF6602"
          stroke="#979797"
          strokeWidth="1.8"
          d="M108.892 99.375c-.895.762-2.025 1.237-3.296 1.237H21.214c-1.27 0-2.4-.475-3.295-1.237l36.445-25.36 4.85-3.377c2.543-1.76 5.84-1.76 8.382 0l4.756 3.33 36.54 25.407z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="1.35"
          d="M19.903 99.253c.287.069.579.104.876.104h84.727c.296 0 .589-.035.875-.104l-39.753-27.25c-2.128-1.443-4.869-1.438-6.977.005L19.903 99.253zm85.603 2.625H20.779c-1.51 0-2.935-.527-4.127-1.522-.302-.25-.47-.63-.45-1.024.02-.394.222-.758.549-.98l41.465-28.423c2.984-2.034 6.858-2.044 9.852 0l4.78 3.3 36.685 25.123c.327.222.53.586.55.98.02.389-.149.773-.45 1.024-1.193.995-2.618 1.522-4.127 1.522h0z"
        />
        <path
          fill="#FFF"
          d="M12.91 27.56c-2.27 1.155-3.572 2.456-4.727 4.726-.481.947-1.813.947-2.294 0-1.155-2.27-2.457-3.571-4.727-4.726-.947-.482-.947-1.813 0-2.295 2.27-1.155 3.572-2.457 4.727-4.727.481-.947 1.813-.947 2.294 0 1.155 2.27 2.457 3.572 4.727 4.727.947.482.947 1.813 0 2.295M129.705 31.617c-1.538.782-2.42 1.664-3.203 3.202-.326.642-1.228.642-1.555 0-.782-1.538-1.664-2.42-3.202-3.202-.641-.327-.641-1.229 0-1.555 1.538-.783 2.42-1.664 3.202-3.202.327-.642 1.229-.642 1.555 0 .783 1.538 1.665 2.42 3.203 3.202.641.326.641 1.228 0 1.555"
        />
      </g>
    </SvgIcon>
  );
};
